import React, { forwardRef, useRef } from 'react'

import monaco from 'monaco-editor'
import Editor, { loader } from '@monaco-editor/react'

import { useOnChange } from '../../hooks/useOnChange'
import { IFormDataVals } from '../../types'

type MonacoProps = {
    controlId: string
    language: string
    height?: number
    width?: number
    onChange?: { ( oldVal?: IFormDataVals, newVal?: IFormDataVals ): void }
}

export const Monaco = ( { controlId, onChange, ...props }: MonacoProps ) => {

    const editorRef = useRef<monaco.editor.IStandaloneCodeEditor | undefined>( undefined )
    
    const { form, onControlChange } = useOnChange( controlId, 'literal', onChange )

    function handleEditorDidMount( editor: monaco.editor.IStandaloneCodeEditor ) {
        editorRef.current = editor;
    }

    return(<Editor
        defaultValue={ form?.data[ controlId ] as string || '' }
        onMount={ handleEditorDidMount }
        onChange={ value => onControlChange( value || '' ) }
        { ...props }
    />)
}